import React from "react";
import css from "./CoachMark.module.scss";
import { coachmark_pin, pointer } from "../../Images/Icons";
import { NavLink } from "react-router-dom";
const CoachMarkStep3 = (props) => {
    
    return (
        <div style={{ position: "relative" }}>
            <div className={css.backdrop}>
                <div className={css.higlight3}>
                    <div className={css.point}>
                        <img src={coachmark_pin}/>
                    </div>
                </div>
                <div className={css.content}>
                    <i class="fi fi-rr-cross-small"></i>
                    <div className={css.title}>🚦 Stay informed about your energy system!</div>
                    <div className={css.desc}>The 'Plant Status' section shows the current condition of your plants: Normal, Faulty, or Offline. Receive instant notifications if any issues arise. Click here to track and manage your plant's health effectively. Let's keep your energy flowing smoothly!</div>
                    <div className={css.step}>3/10</div>
                    <NavLink to="/home" onClick={props.prev}>
                        <button className={css.prev}>Previous</button>
                    </NavLink>
                    <NavLink to="/home" onClick={props.next}>
                        <button className={css.next}>Next</button>
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export default CoachMarkStep3;
